export enum BillingCommitmentType {
  PurchaseOrder = "PurchaseOrder",
  Check = "Check",
  CreditCard = "CreditCard",
  Cash = "Cash",
  Other = "Other",
}
